import { useEffect } from "react";
import { useAuth } from "@/context/AuthContext";

const hexToHsl = (hex) => {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex || "");
  if (!m) return null;
  const [r, g, b] = [1, 2, 3].map((i) => parseInt(m[i], 16) / 255);
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  const d = max - min;
  const s = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));
  let h = 0;
  if (d !== 0) {
    if (max === r) h = ((g - b) / d) % 6;
    else if (max === g) h = (b - r) / d + 2;
    else h = (r - g) / d + 4;
  }
  h = Math.round(h * 60);
  if (h < 0) h += 360;
  return `${h} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
};

const darken = (hsl, amount = 11) => {
  const [h, s, l] = hsl.split(" ");
  return `${h} ${s} ${Math.max(parseInt(l, 10) - amount, 8)}%`;
};

/** Applies each company's own colours across the app — the white-label layer. */
export default function Branding() {
  const { org } = useAuth();

  useEffect(() => {
    const root = document.documentElement;
    const primary = hexToHsl(org?.primary_color);
    const accent = hexToHsl(org?.accent_color);
    if (primary) {
      root.style.setProperty("--royal", primary);
      root.style.setProperty("--royal-deep", darken(primary));
      root.style.setProperty("--primary", primary);
    } else {
      ["--royal", "--royal-deep", "--primary"].forEach((v) => root.style.removeProperty(v));
    }
    if (accent) root.style.setProperty("--gold", accent);
    else root.style.removeProperty("--gold");
  }, [org?.primary_color, org?.accent_color]);

  return null;
}
